import React, {useEffect, useRef} from "react";

import styles from "./Graph.module.scss";
import {isInViewport} from "../../Functions";
import gsap, {Power0} from "gsap";


export default function InterestRemote () {
    const element = useRef(null);

    useEffect(() => {
        const bars = element.current.querySelectorAll('.bar-wrapper rect');
        const lines = element.current.querySelectorAll('polyline');

        gsap.set([bars], {
            attr: {
                transform: 'scale(1,0)'
            }
        });

        Object.values(lines).map(line =>
            gsap.set(line, {
                strokeDasharray: line.getTotalLength(),
                strokeDashoffset: line.getTotalLength(),
            })
        );

        if (element.current && !element.current.classList.contains('animated')) {
            window.addEventListener('scroll', () => {
                if (isInViewport(element.current)) {
                    gsap.to(lines, 3, {
                        ease: Power0.easeOut,
                        strokeDashoffset: 0
                    });

                    Object.values(bars).map((bar, index) =>
                        gsap.to(bar, .7, {
                            transform: 'scale(1,1)',
                            delay: .1 * index
                        })
                    );

                    element.current.classList.add('animated');
                }
            })
        }
    }, []);

    const svg = `
<svg width="723px" height="182px" viewBox="0 0 723 182" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(1.000000, 1.000000)">
            <g stroke-linecap="square" stroke-width="2">
                <path d="M0.5,179.5 L720.5,179.5" stroke="#9B9B9B" opacity="0.795148577"></path>
                <path d="M0.5,0.5 L720.5,0.5" stroke="#D8D8D8"></path>
                <path d="M0.5,134.5 L720.5,134.5" stroke="#D8D8D8"></path>
                <path d="M0.5,89.5 L720.5,89.5" stroke="#D8D8D8"></path>
                <path d="M0.5,44.5 L720.5,44.5" stroke="#D8D8D8"></path>
            </g>
            
            <polyline stroke="#4284F9" stroke-width="3" stroke-linejoin="round" points="0.5 169.274231 39.5 172.670776 119.091339 176.819916 149.687775 169.274231 228.417236 169.274231 303.933594 163.854347 341.384094 172.670776 379.565247 169.274231 416.984253 145.198669 496 149.909958 531.258057 149.909958 570.800598 157 606.59314 172.670776 645.790283 172.670776 684.503723 157 721.262268 157"></polyline>
            <polyline stroke="#FAB303" stroke-width="3" stroke-linejoin="round" points="0.5 176.271667 39.5 173.686707 116.621246 176.271667 149.359589 170.851784 228.250702 170.851784 266.696533 167.929779 303.933594 157 341.384094 170.851784 379.388184 164.342316 416.984253 133.48407 457.478455 129.997437 496 137.076355 531.178162 129.997437 571.219849 137.076355 608.638367 164.342316 645.280579 167.929779 684.232605 137.076355 721.262268 133.48407"></polyline>
            <polyline stroke="#E04334" stroke-width="3" stroke-linejoin="round" points="0.5 173.5 46.7939148 173.5 114.087463 176.271667 149.842131 170.851784 227.306671 170.851784 267.615875 166.613739 302.412964 151.156433 341.176453 162.287872 379.153503 147.786469 454.996399 81.7505188 493.343872 58.2895813 569.178955 18.7546082 645.704285 50.274292 684.519409 0.907989502 721.262268 7.7913208"></polyline>
            <g transform="translate(0.000000, 37.000000)" class="bar-wrapper">
                <text font-family="OpenSans-Regular, Open Sans" font-size="14" font-weight="normal" line-spacing="16" fill="#000000">
                    <tspan x="22" y="76">Moyenne</tspan>
                </text>
                <rect fill="#4284F9" x="22" y="40" width="24" height="13" rotate="180" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                <rect fill="#E04334" x="48" y="0" width="24" height="53" rotate="180" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                <rect fill="#FAB303" x="74" y="35" width="24" height="18" rotate="180" style="transform-origin: 100% 100%; transform-box: fill-box;"></rect>
                <path d="M0.5,52.5 L119.5,52.5" stroke="#9B9B9B" stroke-width="2" opacity="0.795148577" stroke-linecap="square"></path>
            </g>
        </g>
    </g>
</svg>`;

    const legend = `
<svg width="93px" height="137px" viewBox="0 0 93 137" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(0.000000, -4.000000)">
            <text font-family="OpenSans-Semibold, Open Sans" font-size="18" font-weight="500" fill="#000000">
                <tspan x="37" y="79">Teams</tspan>
            </text>
            <rect fill="#FAB303" x="0" y="63" width="19" height="19" rx="9.5"></rect>
            <text font-family="OpenSans-Semibold, Open Sans" font-size="18" font-weight="500" fill="#000000">
                <tspan x="37" y="137">Slack</tspan>
            </text>
            <rect fill="#4284F9" x="0" y="122" width="19" height="19" rx="9.5"></rect>
            <text font-family="OpenSans-Semibold, Open Sans" font-size="18" font-weight="500" fill="#000000">
                <tspan x="37" y="19">Zoom</tspan>
            </text>
            <rect fill="#E04334" x="0" y="4" width="19" height="19" rx="9.5"></rect>
        </g>
    </g>
</svg>`;
    return (
        <div className={styles.Main} ref={element}>
            <div dangerouslySetInnerHTML={{__html: svg}} className={styles.Graph}/>

            <div dangerouslySetInnerHTML={{__html: legend}} className={[styles.Legend, styles.Small].join(' ')}/>
        </div>
    )
}
